import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  NotificationLog,
  NotificationLogListItem,
  NotificationLogsQueryParams,
  NotificationPaginatedResponse,
} from '@models/notifications';
import { map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class NotificationLogsService {
  private readonly url = `${environment.bffUrl}/notification-logs`;
  constructor(private httpClient: HttpClient) {}
  private prevPageNumber: number | null = null;
  private pageSize: number = 100;
  private hasNextPage: boolean = true;

  getPaginated(params?: NotificationLogsQueryParams): Observable<NotificationLogListItem[]> {
    const queryParams = {
      ...(params ? { ...params } : {}),
      pageSize: this.pageSize,
      pageNumber: this.prevPageNumber !== null ? +this.prevPageNumber + 1 : 1,
    };
    if (queryParams.pageNumber !== 1 && !this.hasNextPage) {
      return of([]); // Return an empty observable if there are no more pages to fetch
    }
    return this.httpClient
      .get<NotificationPaginatedResponse>(`${this.url}`, {
        params: queryParams,
      })
      .pipe(
        map(response => {
          this.prevPageNumber = response.pageNumber;
          this.hasNextPage = response.hasNextPage;
          return response.data;
        }),
      );
  }

  getOne(logId: string): Observable<NotificationLog> {
    return this.httpClient.get<NotificationLog>(`${this.url}/${logId}`);
  }

  resetPagination(): void {
    this.prevPageNumber = null;
  }

  resend(logId: string): Observable<NotificationLog> {
    return this.httpClient.post<NotificationLog>(`${this.url}/${logId}/resend`, undefined);
  }

  sendToAnotherEmail(logId: string, email: string): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/${logId}/send-to-another-email`, { email });
  }
}
